var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 558,
    viewBox: "0 0 407 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.083 280.53C161.07 280.522 161.056 280.514 161.043 280.506L325.014 0C362.676 21.476 390.157 56.849 401.412 98.3374C412.668 139.826 406.776 184.031 385.032 221.228C363.288 258.426 327.473 285.569 285.467 296.685C245.007 307.393 201.995 302.388 165.23 282.814L334.16 558H0L161.083 280.53Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/R.b35e61934236602d9b70bf17d4d71b00.svg";
export { ForwardRef as ReactComponent };